export default {
  namespased: true,
  state: {
    // wyświetla loader jeśli loading jest true
    loading: false
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    setLoading: (state, val) => {
      state.loading = val
    },

  }
}